import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import { STATUSES } from "Utils/constants";

// get and filter event data
const filterEvent = async (request) => {

  let status = STATUSES.SUCCESS;
  // Ex. for the request body
  // {
  //   "sorting": "DESC" or "ASC"
  //   "eventType": "All", "Events", "Articles", "Announcements"
  // }

  const url = "/api/event/filterEvent";
  const res = await http.post(url, request, {})
    .then((res) => {
      //console.log("filterEvent()", res);
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
}

// get featured event data
const newsUpdateInit = async () => {

  let status = STATUSES.SUCCESS;
  let body = {}

  const url = "/api/event/newsUpdateInitLoad";
  const res = await http.post(url, body, {})
    .then((res) => {
      //console.log("newsUpdateInit()", res);
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
}

export { filterEvent, newsUpdateInit };